<script lang="ts" setup>
import EntrusterTemplate from '~/components/templates/EntrusterTemplate/EntrusterTemplate.vue';

useAppMeta({
  title: '委託元金融機関に関するご案内',
});
</script>

<template>
  <EntrusterTemplate />
</template>
